<template>
    <div class="blackBg  animated slideInLeft">
        <div class="cardTit">
            <span class="season">{{$store.state.seasonName}}</span>
            <span class="teamName">{{$store.state.teamName.split('_')[0]}}</span>
        </div>
        <div class="cardBg">
            <p class="contTit">Speed</p>
            <div class="teamReport">
                <div class="barTitCol">
                    <span class="titLab titGreen"><Icon type="md-arrow-up" /></span> <span class="titCol titColGreen"></span>
                    <span class="titLab titRed"><Icon type="md-arrow-forward" /></span> <span class="titCol titColRed"></span>
                    <span class="titLab titYellow"><Icon type="md-arrow-down" /></span> <span class="titCol  titColYellow"></span>
                    <span class="titLab titBlue">N/A</span> <span class="titCol titColBlue"></span>
                </div>
                <div class="barBox">
                    <div v-if="labelId!=''" id="speedBar" style="height: 95%;width: 100%"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bodySpeed",
        data(){
            return{
                seasonId:this.$store.state.seasonId,//赛季id
                labelId:"",//标签id
                speedReportItem: [
                    {
                        name: '5m',
                        allData: [],
                        label:" Average 5m",
                        diff:[]
                    },
                    {
                        name: '10m',
                        allData: [],
                        label:" Average 10m",
                        diff:[]
                    },
                    {
                        name: '30m',
                        allData: [],
                        label:" Average 30m",
                        diff:[]
                    }
                ],
                speedReportName:[],//周数组
                speedReportData:[],//ac总数据
                scrollDomWidth:0,//滚动宽度
                scrollTime:0,//滚动时间
                time:null,//定时器
            }
        },
        computed: {
            teamIdFn(){
                return this.$store.state.teamId;
            }
        },
        watch:{
            teamIdFn(val,old){
                if(val!=old){
                    this.info();
                }
            },
        },
        mounted() {
            this.info();
        },
        methods:{
            info(){
                let data={
                    teamId:this.$store.state.teamId
                }
                this.$server.physicalTestLabel(data)
                .then(res=>{
                    this.labelId=res.data.length?res.data[res.data.length-1].id:"";//标签id
                    if(res.data.length){
                        this.getSpeedReportFn();
                    }
                })
            },
            getSpeedReportFn(){
                let data = {
                    physicalTestId:this.labelId
                }
                this.$server.getSpeedReport(data).then((res) => {
                    if(res.code == 200){
                        this.speedReportName = [];
                        this.speedReportData = res.data;
                        for (let i in this.speedReportData){
                            this.speedReportName.push( this.speedReportData[i].playerName);
                            this.speedReportItem[0].allData.push(this.speedReportData[i].fiveMetersTime);
                            this.speedReportItem[1].allData.push(this.speedReportData[i].tenMetersTime);
                            this.speedReportItem[2].allData.push(this.speedReportData[i].thirtyMetersTime);
                            this.speedReportItem[0].diff.push(this.speedReportData[i].fiveMetersTimeDiff);
                            this.speedReportItem[1].diff.push(this.speedReportData[i].tenMetersTimeDiff);
                            this.speedReportItem[2].diff.push(this.speedReportData[i].thirtyMetersTimeDiff);
                        }
                        this.speedReportBar(this.speedReportItem);
                    }
                })
            },
            speedReportBar(data){
                let dom = document.getElementById('speedBar');
                let myChart = this.$echarts.init(dom);
                let lookDom=document.querySelector('.teamReport')
                //柱状图显示宽度
                if(parseInt(lookDom.offsetWidth) > (200 * this.speedReportName.length)){
                    dom.style.width = (parseInt(lookDom.offsetWidth))+'px';
                }else{
                    dom.style.width = (200 * this.speedReportName.length) + "px";
                }
                myChart.resize();
                let option = null;

                let series = [];
                //遍历所得到的数据，分别创建不同的bar->series
                this.speedReportItem.forEach((itemChild,ind)=>{
                    let spedData="";
                    if (itemChild.name == "5m") {
                        spedData = "#48A6E5";
                    } else if (itemChild.name == "10m") {
                        spedData = "#F4682E";
                    } else if (itemChild.name == "30m") {
                        spedData = "#8B80D2";
                    }
                    series.push(
                        {
                            type: 'bar',
                            itemStyle: {
                                normal: {
                                    barBorderRadius: [3, 3, 0, 0],
                                    color: (params)=>{
                                        let index_color = itemChild.diff[ind];
                                        if(index_color>0){
                                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                                offset: 1,
                                                color: '#E1E85B'
                                            },
                                                {
                                                    offset: 0,
                                                    color: '#70FABB'
                                                }]);
                                        }else if(index_color==0){
                                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                                offset: 1,
                                                color: '#EEBC31'
                                            },
                                                {
                                                    offset: 0,
                                                    color: '#FAE586'
                                                }])
                                        }else if(index_color<0){
                                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                                offset: 1,
                                                color: '#EB4511'
                                            },
                                                {
                                                    offset: 0,
                                                    color: '#EC3C3C'
                                                }])
                                        }else{
                                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                                offset: 0,
                                                color: '#2979FF'
                                            },
                                                {
                                                    offset: 1,
                                                    color: '#42A5F5'
                                                }]);
                                        }
                                    }
                                }
                            },
                            data: itemChild.allData,
                            barWidth: 15,
                            label: {
                                show: true,
                                position: 'top',
                                rotate: '90',
                                align: 'left',
                                verticalAlign: 'middle',
                                distance: '5',
                                formatter: function (params) {
                                    if (params.value >= 0) {
                                        return ['{b|'+params.value+'}', '{a|'+itemChild.label+'}'].join('  ');
                                    } else {
                                        return '';
                                    }
                                },
                                rich: {
                                    a: {
                                        color: 'rgba(255, 255, 255, .5)',
                                        fontSize: '14',
                                    },
                                    b: {
                                        color: 'rgba(255, 255, 255, .8)',
                                        fontSize: '16',
                                        fontWeight: '600'
                                    }
                                },
                            },
                            markLine: {
                                symbol: ["none", "none"], //去掉箭头
                                lineStyle: {
                                    color: spedData,
                                    type: "solid"
                                },
                                label: {
                                    position: "insideStartTop",
                                    fontSize: 14,
                                    formatter: function(params) {
                                        return params.value +" " +itemChild.label;
                                    }
                                },
                                data: [{ type: "average", name: "" }]
                            }
                        }
                    )
                })

                option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        top: '25%',
                        left: '0',
                        right: '5%',
                        bottom: '0',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.speedReportName,
                            axisLabel: {
                                color:'#fff',
                                fontSize:16,
                                margin:20,
                            },
                            axisLine: {       // 坐标轴 轴线
                                show: true,  // 是否显示
                                // ------   线 ---------
                                lineStyle: {
                                    color: 'rgba(255, 255, 255, .5)',
                                    width: 1,
                                    type: 'solid',
                                    opacity: '0.3',
                                }
                            },
                            splitLine :{
                                lineStyle:{
                                    color: '#666',
                                    opacity: '0.3',
                                    type:'dotted'
                                },
                                show:true
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            max: function (value) {
                                return value.max+2;
                            },
                            axisLabel: {
                                color:'#fff',
                                fontSize:16,
                                margin:15,
                            },
                            axisLine: {       // 坐标轴 轴线
                                show: true,  // 是否显示
                                // ------   线 ---------
                                lineStyle: {
                                    color: 'rgba(255, 255, 255, .5)',
                                    width: 1,
                                    type: 'solid',
                                    opacity: '0.3',
                                }
                            },
                            splitLine :{
                                lineStyle:{
                                    color: '#666',
                                    opacity: '0.3',
                                    type:'dotted',
                                    fontSize:16,
                                },
                                show:true
                            }
                        }
                    ],
                    series: series
                };
                myChart.setOption(option, true);
                if(this.speedReportName.length){
                    let timeScroll=null
                    timeScroll=setTimeout(()=>{
                        const lookEl=document.querySelector('.teamReport')
                        const el = document.querySelector('#speedBar');
                        this.scrollDomWidth= el.offsetWidth - lookEl.offsetWidth+100;
                        this.scrollTime= 3 +Math.floor(this.scrollDomWidth/500)*5
                        if(this.scrollDomWidth>100){
                            clearInterval(this.time)
                            this.time = setInterval(this.scroll,(this.scrollTime*1000)+500)
                        }
                        clearInterval(timeScroll)
                    })
                }
            },
            //滚动
            scroll(){
                const el = document.querySelector('#gpsBar');
                let style=el?el.getAttribute('style'): '';
                let styleStr='';
                if(style && style == 'margin-left:'+ -(this.scrollDomWidth)+'px;transition: all linear '+ this.scrollTime +'s'){
                    styleStr='margin-left:0px;transition: all linear '+ this.scrollTime +'s'
                }else {
                    styleStr='margin-left:'+ -(this.scrollDomWidth)+'px;transition: all linear '+ this.scrollTime +'s'
                }
                el?el.setAttribute('style',styleStr):'';
            }
        },
        beforeDestroy() {
            clearInterval(this.time);
        }
    }
</script>

<style scoped lang="less">
    .cardTit{
        background-image: url("../assets/img/updateImg/head_2.png");
        position: relative;
        font-size: 30px;
        .season{
            font-family: PingFangMedium;
            color: #fff;
            display: inline-block;
            position: absolute;
            line-height: 130px;
            left: 2vw;
        }
    }
    .cardBg{
        height: calc(100% - 115px);
        box-sizing: border-box;
        padding: 2vw;
        color: #fff;
        position: relative;
        .contTit{
            font-size: 30px;
        }
        .barTitCol{
            padding-bottom: 1vw;
            margin-right: 1vw;
            position: absolute;
            right: 3vw;
            top: 3.4vw;
            font-size: 26px;
            span {
                float: right;
            }
            .titCol {
                width: 20px;
                height: 20px;
            }
            .titColRed {
                background: #F34E4E;
            }
            .titColGreen {
                background: #76C072;
            }
            .titColYellow {
                background: #F3C74E;
            }
            .titColBlue {
                background: #7AAAF0;
            }
            .titLab {
                font-family: PingFang;
                color: #fff;
                padding-left: .5vw;
                padding-right: 1.5vw;
                margin-top: -8px;
            }
            .titGreen{
                color: #76C072;
            }
            .titYellow{
                color: #F3C74E;
            }
            .titRed{
                color: #F34E4E;
            }
            .titBlue{
                color: #7AAAF0;
            }
        }
        .teamReport{
            height: calc(100% - 2vw);
        }
        .barBox{
            margin-right: 1vw;
            margin-left: 1vw;
            width: calc( 100% - 2vw);
            height: 100%;
            overflow-x: auto;
            overflow-y: hidden;
        }
    }
</style>
